import { render } from "./TermsOfUseCheckbox.vue?vue&type=template&id=5b9d6c7d&scoped=true"
import script from "./TermsOfUseCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsOfUseCheckbox.vue?vue&type=script&lang=js"

import "./TermsOfUseCheckbox.vue?vue&type=style&index=0&id=5b9d6c7d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9d6c7d"]])

export default __exports__